import {
  categoryEducationCoverImage,
  categoryEducationIconImage,
  categoryEnvironmentCoverImage,
  categoryEnvironmentIconImage,
  categoryHumanRightsCoverImage,
  categoryHumanRightsIconImage,
  categoryTechnologyCoverImage,
  categoryTechnologyIconImage,
} from '@/features/theme/assets/images';

export const THEME_CATEGORIES = [
  {
    code: 'global_environment',
    title: '地球環境',
    coverImage: categoryEnvironmentCoverImage,
    iconImage: categoryEnvironmentIconImage,
  },
  {
    code: 'tech_and_society',
    title: '技術と社会',
    coverImage: categoryTechnologyCoverImage,
    iconImage: categoryTechnologyIconImage,
  },
  {
    code: 'human_rights',
    title: '暮らしと権利',
    coverImage: categoryHumanRightsCoverImage,
    iconImage: categoryHumanRightsIconImage,
  },
  {
    code: 'new_economy',
    title: '新しい経済',
    coverImage: categoryEducationCoverImage,
    iconImage: categoryEducationIconImage,
  },
];
